import { computed } from 'vue'
import { useWorkspaceStore } from '@/stores/workspace'

/**
 * The products the selected organization has access to right now, readable by any of its members,
 * unlike its subscriptions. Undefined until an organization is selected.
 */
export function useSubscribedProducts() {
  const workspace = useWorkspaceStore()

  return computed(() => workspace.currentOrganization?.subscribedProducts)
}
